/*
 * @Description: 提示信息
 * @Author: PF
 * @Date: 2022-11-15 15:25:27
 * @LastEditors: PF
 * @LastEditTime: 2025-05-27 11:55:53
 */

import { ElNotification, ElMessage, ElMessageBox } from 'element-plus'
// 成功提示
export function successPrompt (data) {
  if (document.getElementsByClassName('el-message-box').length === 0) {
    return ElNotification({
      title: '提示',
      message: data,
      type: 'success',
      position: 'bottom-right',
      duration: 3000
    })
  }
}
// 消息提示
export function messagePrompt (data) {
  if (document.getElementsByClassName('el-message-box').length === 0) {
    return ElMessage(data)
  }
}
// 警告提示
export function warningPrompt (data) {
  if (document.getElementsByClassName('el-message-box').length === 0) {
    return ElMessageBox.confirm(data, '警告',
      {
        showCancelButton: false,
        confirmButtonText: '关闭',
        type: 'warning'
      }
    )
  }
}
// 错误提示
export function errorPrompt (data) {
  if (document.getElementsByClassName('el-message-box').length === 0) {
    return ElMessageBox.confirm(data, '错误',
      {
        showCancelButton: false,
        confirmButtonText: '关闭',
        type: 'error'
      }
    )
  }
}
// 成功提示
export function successLePrompt (data) {
  return ElNotification({
    title: '提示',
    message: data,
    type: 'success',
    position: 'bottom-right',
    duration: 3000
  })
}
// 消息提示
export function messageLePrompt (data) {
  return ElMessage(data)
}
// 警告提示
export function warningLePrompt (data) {
  return ElMessageBox.confirm(data, '警告',
    {
      showCancelButton: false,
      confirmButtonText: '关闭',
      type: 'warning'
    }
  )
}
// 错误提示
export function errorLePrompt (data) {
  return ElMessageBox.confirm(data, '错误',
    {
      showCancelButton: false,
      confirmButtonText: '关闭',
      type: 'error'
    }
  )
}
